export default __webpack_public_path__ + "static/media/EditIcon.924152bf.svg";